export default __webpack_public_path__ + "static/media/video.54ab8311.jpg";